import { gql } from '@apollo/client';

export const partnerProductFieldsFragment = gql`fragment PartnerProductFields on PartnerProduct {
  _id
  title
  dbId
  productType
  description
  bonusValue
  discountPercents
  priceOptions {
    priceOptionId
    title
    price
    bonusValue
    bonusPaymentType
    currency
    isActive
  }
  isActive
  createdAt
  updatedAt
}
`;

export const findManyPartnerProductQuery = gql`
  ${partnerProductFieldsFragment}
  query findManyPartnerProductQuery($filter: FilterFindManyPartnerProductInput) {
    findManyPartnerProductQuery(filter: $filter) {
      ...PartnerProductFields
    }
  }
`;

export const createOnePartnerProductMutation = gql`
  ${partnerProductFieldsFragment}
  mutation createOnePartnerProductMutation($record: CreateOnePartnerProductInput!) {
    createOnePartnerProductMutation(record: $record) {
      record {
        ...PartnerProductFields
      }
    }
  }
`;

export const updateByIdPartnerProductMutation = gql`
  ${partnerProductFieldsFragment}
  mutation updateByIdPartnerProductMutation($_id: MongoID!, $record: UpdateByIdPartnerProductInput!) {
    updateByIdPartnerProductMutation(_id: $_id, record: $record) {
      record {
        ...PartnerProductFields
      }
    }
  }
`;

export const removePartnerProductMutation = gql`mutation removePartnerProductMutation($_id: MongoID!) {
  removePartnerProductMutation(_id: $_id) {
    _id
  }
}
`;
